/* import __COLOCATED_TEMPLATE__ from './muxed-tab.hbs'; */
import Component from '@ember/component';
import { service } from '@ember/service';

export default class MuxedTab extends Component {
    tagName = '';

    @service intl;
    @service('data') model;

    muxedInputSignalBodyArgs = {};

    init() {
        super.init();

        this.muxedInputSignalBodyArgs = {
            analogDemystifyingDataArticleLink: this.intl.t('urls.articles.demystifyingData'),
            analogFrontEndDesignArticleLink: this.intl.t('urls.articles.frontEndDesign'),
        };
    }
}
